<template>
  <div class="pt-0 companymanage" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA;">
    <!-- <h2 class="txt-head">
      เพิ่มบริษัทใหม่
    </h2> -->
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          เพิ่มบริษัท
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="button-color-outline ma-0" outlined dark @click="goBack()">ยกเลิก</v-btn>
        <v-btn width="18%" class="button-color ma-2 mr-5" dark @click="dialogConfirmSubmitData = true">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <div>
      <v-expansion-panels
        accordion
        v-model="panel"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="text-sub-color ra-head-text-bold" style="font-size: 16px;">ข้อมูลบริษัท</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout class="pa-2 pr-2" style="margin-top: -2%;">
              <v-row>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12">
                    <span class="txt-head">รายละเอียดบริษัท<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรอกข้อมูลรายละเอียดบริษัททั้งหมดให้ครบถ้วน)</span></span>
                  </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเครือ</p>
                  <v-select
                    v-model="groupName"
                    :items="itemCompany"
                    item-text="groupCompanyNameEng"
                    item-value="_id"
                    label="เลือก เครือ"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(ไทย)*</p>
                  <v-text-field
                    v-model="companyNameShortTh"
                    label="ชื่อย่อบริษัท(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(อังกฤษ)*</p>
                  <v-text-field
                    v-model="companyNameShortEng"
                    label="ชื่อย่อบริษัท(อังกฤษ)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(ไทย)*</p>
                  <v-select
                    v-model="legalEntityTh"
                    :items="['ไม่มี','ห้างหุ่นส่วนสามัญ', 'ห้างหุ่นส่วนจำกัด', 'บริษัทจำกัด', 'บริษัทมหาชนจำกัด', 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ']"
                    label="กรุณาเลือกประเภทนิติบุคคล(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(ไทย)*</p>
                  <v-text-field
                    v-model="companyNameFullTh"
                    label="ชื่อบริษัท(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(ไทย)*</p>
                  <v-text-field
                    v-model="nameUseInDocTh"
                    label="ชื่อสำหรับแสดงบนเอกสาร(ไทย)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(อังกฤษ)*</p>
                  <v-select
                    v-model="legalEntityEng"
                    :items="['None','Ordinary Partnership', 'Limited Partnership', 'Company Limited', 'Public Limited Company', 'Other']"
                    label="Please choose a legal entity"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(อังกฤษ)*</p>
                  <v-text-field
                    v-model="companyNameFullEng"
                    label="ชื่อบริษัท(อังกฤษ)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)*</p>
                  <v-text-field
                    v-model="nameUseInDocEng"
                    label="ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="4">
                  <p class="txt-font" style="margin-top: 0%;">หนังสือรับรองนิติบุคคล</p>
                  <v-text-field
                    v-model="nameUseInDocEng"
                    label="อัปโหลดหนังสือรับรองนิติบุคคล"
                    style="font-size: 10px;"
                    dense
                    outlined
                    readonly
                  >
                    <template v-slot:append>
                      <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
                        <v-btn
                          depressed
                          color="#EFF4FD"
                          class=""
                          small
                          style="margin-top: -2%;"
                          v-on:click="addFiles('certificate')"
                          readOnly
                        >
                        <span style="color: #3776E9">เลือกไฟล์</span>
                        </v-btn>
                    </template>
                  </v-text-field>
                </v-col> -->
                <v-col cols="4" md="3" sm="3" lg="4" xl="3">
                  <p class="txt-font" style="margin-top: 0%;">หนังสือรับรองนิติบุคคล</p>
                  <div class="box-image3 mt-1">
                  <v-row>
                    <v-col cols="7">
                      <span v-if="filesCertificate.length === 0" class="text-right ml-5" style="color: #999999; font-size: 12px; margin-top: 0%;">อัปโหลดหนังสือรับรองนิติบุคคล</span>
                      <input type="file" id="files" ref="PickfilesCertificate" multiple v-on:change="onFileSelected('certificate')"/>
                      <div v-for="(file, key) in filesCertificate" :name="file.name" class="file-listing ml-1 mt-0" :key="key">
                        <!-- <v-icon left dark color="red">fa-file-pdf</v-icon> -->
                        <!-- <span class="mb-5" close :id="key" :name="file.name" @click:close="removeFile(key, 'certificate')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</span> -->
                        <v-chip class="" close :id="key" :name="file.name" @click:close="removeFile(key, 'certificate')" style="margin-top: -2%;"><strong>{{ file.name }}</strong>&nbsp;</v-chip>
                      </div>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        id="btnbrowse"
                        name="btnbrowse"
                        depressed
                        color="#EFF4FD"
                        class="ml-3"
                        small
                        style="margin-top: -38%; margin-right: -20%;"
                        v-on:click="addFiles('certificate')"
                        readOnly
                      >
                      <span class="txt-font ml-3" style="color: #3776E9;">เลือกไฟล์</span>
                      <!-- <v-icon left dark color="white">fa-upload</v-icon>
                        <span class="txt-font" style="#3776E9">เลือกไฟล์</span> -->
                      </v-btn>
                    </v-col>
                  </v-row>
                  </div>
                  <v-progress-linear
                    v-show="loadingFile === true"
                    indeterminate
                    color="cyan darken-0"
                  ></v-progress-linear>
                  <p class="txt-font" style="margin-top: 5%;">อัปโหลดได้เฉพาะไฟล์ .pdf เท่านั้น</p>
                </v-col>
              </v-row>
            </v-layout>
            <v-layout class="pa-5 pr-5 mt-5">
              <v-row>
                <v-col cols="12" class="from-control">
                  <span class="txt-head" style="font-weight: bold;">ที่อยู่บริษัท</span>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เลขรหัสประจำที่อยู่</p>
                  <v-text-field
                    v-model="companyAddressDetail.codeAddress"
                    label="เลขรหัสประจำที่อยู่"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ที่อยู่*</p>
                  <v-text-field
                    v-model="companyAddressDetail.address"
                    label="ที่อยู่"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ห้องเลขที่</p>
                  <v-text-field
                    v-model="companyAddressDetail.roomNo"
                    label="ห้องเลขที่"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชั้นที่</p>
                  <v-text-field
                    v-model="companyAddressDetail.floorNo"
                    label="ชั้นที่"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อาคาร</p>
                  <v-text-field
                    v-model="companyAddressDetail.buildingName"
                    label="อาคาร"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">หมู่บ้าน</p>
                  <v-text-field
                    v-model="companyAddressDetail.villageName"
                    label="หมู่บ้าน"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">หมู่ที่</p>
                  <v-text-field
                    v-model="companyAddressDetail.villageNo"
                    label="หมู่ที่"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ตรอก/ซอย</p>
                  <v-text-field
                    v-model="companyAddressDetail.alley"
                    label="ตรอก/ซอย"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">แยก</p>
                  <v-text-field
                    v-model="companyAddressDetail.dispart"
                    label="แยก"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ถนน</p>
                  <v-text-field
                    v-model="companyAddressDetail.road"
                    label="ถนน"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">จังหวัด*</p>
                  <v-select
                    v-model="companyAddressDetail.province"
                    :items="$store.state.province_th_list"
                    label="กรุณาเลือกจังหวัด"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อำเภอ/เขต*</p>
                  <v-text-field
                    v-model="companyAddressDetail.district"
                    label="อำเภอ/เขต"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ตำบล/แขวง*</p>
                  <v-text-field
                    v-model="companyAddressDetail.subDistrict"
                    label="ตำบล/แขวง"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">รหัสไปรษณีย์*</p>
                  <v-text-field
                    v-model="companyAddressDetail.postCode"
                    label="รหัสไปรษณีย์"
                    :rules="inputRules"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <p class="txt-font" style="margin-top: 0%;">รูปภาพ บริษัท*</p>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        class="base-image-input elevation-1"
                        :style="{ 'background-image': `url(${imageUrl})` }"
                        @click="ChooseBanner()"
                      >
                        <span
                          v-if="!imageUrl"
                          class="placeholder-image"
                        >
                          <!-- เลือกรูปภาพ -->
                        </span>
                        <input
                          class="file-input"
                          id="files"
                          ref="Pickfiles"
                          type="file"
                          v-on:change="onBannerSelected()"
                        >
                      </div>
                    </template>
                    <span class="txt-font" v-if="imageUrl !== ''" style="color: white;">กดอีกครั้งเพื่อเลือกรูปใหม่</span>
                    <span class="txt-font" v-if="imageUrl === ''" style="color: white;">กดเพื่อเลือกรูป</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="text-sub-color ra-head-text-bold" style="font-size: 16px;">ข้อมูลผู้เสียภาษี</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout class="pa-2 pr-2">
              <v-row>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เลขที่ผู้เสียภาษีอากร*</p>
                  <v-text-field
                    v-model="taxId"
                    label="เลขที่ผู้เสียภาษีอากร"
                    :rules="inputRules"
                    type="number"
                    maxlength="13"
                    required
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">อีเมล*</p>
                  <v-text-field
                    v-model="email"
                    label="อีเมล"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ภูมิภาค/Region*</p>
                  <v-select
                    v-model="region"
                    :items="['Northern', 'Northeastern', 'Central', 'Southern']"
                    label="Please choose a legal entity"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">ชื่อสาขา*</p>
                  <v-text-field
                    v-model="branchName"
                    label="ชื่อสาขา"
                    :rules="inputRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">รหัสสาขา*</p>
                  <v-text-field
                    v-model="branchCode"
                    label="รหัสสาขา"
                    :rules="inputRules"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เบอร์โทรศัพท์</p>
                  <v-text-field
                    v-model="companyTelNo"
                    label="เบอร์โทรศัพท์"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">เบอร์มือถือ*</p>
                  <v-text-field
                    v-model="companyMobilNumber"
                    label="เบอร์มือถือ"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="form-control">
                  <p class="txt-font" style="margin-top: 0%;">โทรสาร</p>
                  <v-text-field
                    v-model="fax"
                    label="เบอร์โทรสาร"
                    type="number"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="text-sub-color ra-head-text-bold" style="font-size: 16px;">ข้อมูลผู้ดูแล</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-if="approver.length === 0" class="mt-0 mb-8" justify=center>
              <v-col cols="8" class="text-center">
                <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลผู้ดูแล</span>
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="ra-head-text">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้ดูแลของคุณ</span>
              </v-col>
              <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
                <v-btn
                  class="button-color ra-button-company"
                  dark
                  @click="openDialogAddAprover('add', '', '', 'approver')"
                >
                <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
                <span class="ra-text-in-button-company">
                  เพิ่มผู้ดูแล
                </span>
              </v-btn>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12"
              >
                <v-data-table
                  :hide-default-footer="true"
                  :headers="headers"
                  :items="approver"
                  sort-by="no"
                  class="elevation-0"
                >
                <template v-slot:[`item.no`]="{ item }">
                  {{ approver.indexOf(item)+1 }}
                </template>
                <template v-slot:[`item.userImg`]="{ item }">
                  <!-- {{item.userImg}} -->
                  <td style="width: fit-content !important;" class="py-3">
                    <!-- <v-img :src="item.userImg" class="img-border" style="width: 70px; height: 70px" aspect-ratio="2.7"/> -->
                    <v-avatar
                      size="44"
                      rounded
                      >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.employeeId"
                        v-on:error="onImgError(i)"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    <!-- {{item.companyImg}} -->
                    </td>
                </template>
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <!-- <v-toolbar-title>My CRUD</v-toolbar-title> -->
                      <!-- <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider> -->
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        color="button-color-outline"
                        dark
                        class="button-color-outline mb-2"
                        @click="openDialogAddAprover('add', '', '', 'approver')"
                      >
                      <v-icon left dark class="icon-eye-color" size="14px">fa-plus</v-icon>
                      <span class="ra-text-in-button-company" style="font-weight:bold;">
                        เพิ่มผู้ดูแล
                      </span>
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <!-- <v-btn class="ma-2" outlined x-small fab color="indigo" @click="editCompany('Edit Company')"> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, approver.indexOf(item), 'approver')"
                        >
                        <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
                          <template v-slot>
                            <v-icon color="#2BA197" small>mdi-pencil-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="ra-border-button mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                        <!-- <v-icon dark color="#464646" small>fa-trash</v-icon> -->
                          <template v-slot>
                            <v-icon color="error" small>mdi-delete-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                    <!-- <v-btn class="ma-2" outlined x-small fab color="green" @click="openDialogManageCompany()">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn> -->
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header color="#FFFFFF" class="text-sub-color ra-head-text-bold" style="font-size: 16px;">ข้อมูลผู้รักษาการ</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row v-if="temporaryer.length === 0" class="mt-0 mb-8" justify=center>
              <v-col cols="8" class="text-center">
                <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลผู้รักษาการ</span>
              </v-col>
              <v-col cols="8" class="text-center" style="margin-top: -1%;">
                <span class="ra-head-text">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้รักษาการของคุณ</span>
              </v-col>
              <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
                <v-btn
                  outlined
                  class="button-color ra-button-company"
                  dark
                  @click="openDialogAddAprover('add', '', '', 'temporaryer')"
                >
                <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
                <span class="ra-text-in-button-company">
                  เพิ่มผู้รักษาการ
                </span>
              </v-btn>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12"
              >
              <div>
                <v-data-table
                  :headers="headersTemporary"
                  :items="temporaryer"
                  class="border-table-company text-no-wrap mt-1"
                  item-key="_id"
                  :loading="loading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.no`]="{ item }">
                    {{ temporaryer.indexOf(item)+1 }}
                  </template>
                  <template v-slot:[`item.poaNo`]="{ item }">
                    {{ item.poaNo|| '-' }}
                  </template>
                  <template v-slot:[`item.name`]="{ item }">
                    <v-icon left dark color="red">fa-file-pdf</v-icon>
                    <span class="txt-font">{{item.name}}</span>
                    <!-- <v-icon right dark color="#6B96F8">fa-download</v-icon> -->
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                  <span>{{ item.date || '-' }}</span>
                  </template>
                  <template v-slot:[`item.userImg`]="{ item }">
                    <!-- {{item.userImg}} -->
                    <td style="width: fit-content !important;" class="py-3">
                      <!-- <v-img :src="item.userImg" class="img-border" style="width: 70px; height: 70px" aspect-ratio="2.7"/> -->
                      <v-avatar
                        size="44"
                        rounded
                        >
                        <v-img
                          class="card-header-userimg-border"
                          cover
                          :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                          :alt="item.employeeId"
                          v-on:error="onImgError(i)"
                          aspect-ratio="1"
                          height="100%"
                        />
                      </v-avatar>
                      <!-- {{item.companyImg}} -->
                      </td>
                  </template>
                  <template v-slot:top>
                      <v-toolbar
                        flat
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          outlined
                          dark
                          class="button-color-outline mb-2"
                          @click="openDialogAddAprover('add', '', '', 'temporaryer')"
                        >
                        <v-icon left dark class="icon-eye-color" size="14px">fa-plus</v-icon>
                        <span class="ra-text-in-button-company" style="font-weight:bold;">
                          เพิ่มผู้รักษาการ
                        </span>
                        </v-btn>
                      </v-toolbar>
                    </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <!-- <v-btn class="ma-2" outlined x-small fab color="indigo" @click="editCompany('Edit Company')"> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, temporaryer.indexOf(item), 'temporaryer')"
                        >
                        <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
                          <template v-slot>
                            <v-icon color="#2BA197" small>mdi-pencil-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="ra-border-button mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'temporaryer')"
                        >
                        <!-- <v-icon dark color="#464646" small>fa-trash</v-icon> -->
                          <template v-slot>
                            <v-icon color="error" small>mdi-delete-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                    <!-- <v-btn class="ma-2" outlined x-small fab color="green" @click="openDialogManageCompany()">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn> -->
                  </template>
                  <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
                    <v-row class="d-flex px-4">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }"
                        >
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            small
                            dark
                            icon
                            class="ra-border-button mt-3 mb-3"
                            @click="openDialogAddAprover('edit', item, temporaryer.indexOf(item), 'temporaryer')"
                          >
                          <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
                            <template v-slot>
                              <img width="17" height="17" src="@/assets/icons/edit-icon.png" >
                            </template>
                          </v-btn>
                        </template>
                        <span class="label-table-action">จัดการผู้ดูแล</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ attrs }">
                          <v-btn
                            v-bind="attrs"
                            rounded
                            dark
                            small
                            icon
                            class="ra-border-button mt-3 mb-3 ml-2"
                            @click="checkRemove(item, 'temporaryer')"
                          >
                          <!-- <v-icon dark color="#464646" small>fa-trash</v-icon> -->
                            <template v-slot>
                              <img width="17" height="17" src="@/assets/icons/delete-icon.png" >
                            </template>
                          </v-btn>
                        </template>
                        <span class="label-table-action">ลบผู้ดูแล</span>
                      </v-tooltip>
                    </v-row>
                  </template>
                </v-data-table>
              </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-row>
            <v-col cols="12">
              <span class="txt-head">ดาวน์โหลดแบบฟอร์ม<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรุณาดาวน์โหลดแบบฟอร์มในการกรอกข้อมูลเพื่อใช้ในการเพิ่มผู้รักษาการ)</span></span>
            </v-col>
            <v-col cols="12">
              <v-btn
                id="btnbrowse"
                name="btnbrowse"
                right
                rounded
                color="#FFFFFF"
                dark
                class="mr-2 ml-2 pa-5 align-center btn_click"
                @click="getFormAuth()"
              >
                <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
                <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจ.doc</span>
                <v-icon right dark color="#6B96F8">fa-download</v-icon>
              </v-btn>
              <v-btn
                id="btnbrowse"
                name="btnbrowse"
                right
                rounded
                color="#FFFFFF"
                dark
                class="mr-0 ml-2 pa-5 align-center btn_click"
                @click="getFormPoa()"
              >
                <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
                <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจช่วง.doc</span>
                <v-icon right dark color="#6B96F8">fa-download</v-icon>
              </v-btn>
            </v-col>
        </v-row>
      </v-expansion-panels>
    </div>
    </v-form>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span v-if="titleDialog === 'approver'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้ดูแลคนนี้</span>
        <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogDeleteApprover = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="removeApprover(itemConfirmDelete, titleDialog)">ลบข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSubmitData" max-width="500px" persistent>
      <v-card >
        <v-card-title class="text-sub-color ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล <br>(หากต้องการเพิ่มพนักงานต้องมีตำแหน่งงานในบริษัทก่อน)<br></span>
        <!-- <span class="ra-head-text justify-center">(หากต้องการเพิ่มพนักงานต้องมีตำแหน่งงานในบริษัทก่อน)</span> -->
        </v-card-text>
        <v-card-actions class="">
          <!-- <v-spacer></v-spacer> -->
          <v-row class="text-center" style="margin-top: -2%">
            <v-col cols="12">
              <v-btn class="button-color"  dark @click="submitDataCreate('/managecompany')">บันทึก และกลับไปหน้าจัดการเครือและบริษัท </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn class="button-color-outline" outlined @click="submitDataCreate('/manageposition')">บันทึก และไปยังหน้าเพิ่มตำแหน่งงาน</v-btn>
            </v-col>
            <v-col cols="12">
              <span class="" color="#757575" style="cursor: pointer;" @click="dialogConfirmSubmitData = false">ยกเลิก</span>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
      </v-row>
    </div>
    <DialogAddAprover/>
    <DialogAddTemporaryer/>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import DialogAddAprover from '../manageCompany/_dialog/dialogAddApprover'
import DialogAddTemporaryer from '../manageCompany/_dialog/dialogAddTemporaryer.vue'
import { getUserByKeyword, insertCompany } from '@/API/API'
export default {
  components: {
    DialogAddAprover,
    DialogAddTemporaryer
  },
  name: 'overview',
  data () {
    return {
      loading: false,
      loadingFile: false,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDeleteApprover: false,
      dialogConfirmSubmitData: false,
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 0],
      chkDataEmp: 0,
      imageData: null,
      legalEntityTh: '',
      legalEntityEng: '',
      nameUseInDocTh: '',
      nameUseInDocEng: '',
      groupName: '',
      companyNameEng: '',
      companyNameTh: '',
      itemCompany: [],
      taxId: '',
      email: '',
      branchName: '',
      branchCode: '',
      companyTelNo: '',
      companyMobilNumber: '',
      fax: '',
      companyAddressDetail: {
        codeAddress: '',
        address: '',
        roomNo: '',
        floorNo: '',
        buildingName: '',
        villageName: '',
        villageNo: '',
        alley: '',
        dispart: '',
        road: '',
        province: '',
        district: '',
        subDistrict: '',
        postCode: ''
      },
      region: '',
      companyNameFullEng: '',
      companyNameFullTh: '',
      companyNameShortEng: '',
      companyNameShortTh: '',
      address: '',
      files: [],
      filesCertificate: [],
      filesPoa: [],
      filesAuth: [],
      tel: '',
      img: '',
      tab: null,
      imageUrl: '',
      type_files: ['pdf', 'png', 'jpg', 'jpeg', 'tiff', 'gif', 'rar', 'zip', '7z'],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ],
      tokenUser: '',
      userIdList: [],
      userIdListTemporary: [],
      approver: [
        // {
        //   no: 1,
        //   _id: '1212xx',
        //   employeeId: 'sittikorn0993',
        //   approverName: 'นายสมพงษ์ อิอิ',
        //   position: 'ตำแหน่ง xxxx',
        //   email: 'kookkai@one.th',
        //   userImg: 'https://picsum.photos/200',
        //   failed_image: true
        // }
      ],
      temporaryer: [],
      isSelecting: false,
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
        // v => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: 'date' },
        { text: 'หนังสือมอบอำนาจ', value: 'name' },
        { text: 'เลขที่หนังสือมอบอำนาจ', value: 'poaNo' },
        // { text: 'จัดการ', value: 'actions', sortable: false }
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }

      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getSelectCompany()
  },
  computed: {
  },
  watch: {
    legalEntityTh: function (val) {
      if (val === 'ห้างหุ่นส่วนสามัญ') {
        this.legalEntityEng = 'Ordinary Partnership'
      } else if (val === 'ห้างหุ่นส่วนจำกัด') {
        this.legalEntityEng = 'Limited Partnership'
      } else if (val === 'บริษัทจำกัด') {
        this.legalEntityEng = 'Company Limited'
      } else if (val === 'บริษัทมหาชนจำกัด') {
        this.legalEntityEng = 'Public Limited Company'
      } else if (val === 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ') {
        this.legalEntityEng = 'Other'
      } else if (val === 'ไม่มี') {
        this.legalEntityEng = 'None'
      }
    },
    legalEntityEng: function (val) {
      if (val === 'Ordinary Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนสามัญ'
      } else if (val === 'Limited Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนจำกัด'
      } else if (val === 'Company Limited') {
        this.legalEntityTh = 'บริษัทจำกัด'
      } else if (val === 'Public Limited Company') {
        this.legalEntityTh = 'บริษัทมหาชนจำกัด'
      } else if (val === 'Other') {
        this.legalEntityTh = 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ'
      } else if (val === 'None') {
        this.legalEntityTh = 'ไม่มี'
      }
    }
  },
  methods: {
    goBack () {
      // this.$router.go(-1)
      this.$router.push('/managecompany')
    },
    cancel () {
      this.files[0] = []
      this.groupName = ''
      this.filesCertificate[0] = []
      this.filesPoa[0] = []
      this.companyNameShortTh = ''
      this.companyNameShortEng = ''
      this.legalEntityTh = ''
      this.companyNameFullTh = ''
      this.nameUseInDocTh = ''
      this.taxId = ''
      this.email = ''
      this.taxId = ''
      this.region = ''
      this.branchName = ''
      this.branchCode = ''
      this.branchName = ''
      this.companyMobilNumber = ''
      this.companyAddressDetail = ''
      this.userIdList = []
      this.userIdListTemporary = []
      this.approver = []
      this.temporaryer = []
    },
    onImgError (i) {
      // console.log('method: ', i)
      this.approver[i].failed_image = true
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      }).then((response) => {
        var dataReverse = response.data.result
        this.itemCompany = dataReverse
        // console.log('revers/e', this.itemCompany)
        this.itemCompany.push({
          _id: '',
          groupCompanyNameEng: 'ไม่มี'
        })
        this.itemCompany = this.itemCompany.reverse()
      }).catch(e => {
        console.log(e)
      })
    },
    async getUserDefault () {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        search: this.$store.state.user.employeeId
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          var filterValue = this.approver.filter(r => {
            if (r.position === res.result[0].position.positionName && r._id === res.result[0].id && r.approverName === res.result[0].name) {
              return r
            }
          })
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: res.result[0].id,
              employeeId: res.result[0].employeeId,
              approverName: res.result[0].name,
              position: res.result[0].position.positionName,
              email: res.result[0].email,
              userImg: this.api + '/' + res.result[0].userImg,
              approveType: res.result[0].approveType,
              companyId: res.result[0].companyId,
              failed_image: false
            })
            this.userIdList.push({
              userId: res.result[0].id,
              companyId: res.result[0].companyId
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async getFormAuth () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจ.doc')
      }).catch(e => {
        console.log(e)
      })
    },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadSPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจช่วง.docx')
      }).catch(e => {
        console.log(e)
      })
    },
    openDialogAddAprover (action, item, index, type) {
      // temporaryer
      if (type === 'temporaryer') {
        // console.log('add', type)
        EventBus.$emit('openDialogTemporaryer', true, item, action, index, type)
      } else {
        EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
      }
    },
    add (value, index, action, type) {
      // var today = new Date()
      // var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
      var filterValue = this.approver.filter(r => {
        if (r.position === value.position && r.employeeId === value.employeeId) {
          return r
        }
      })
      var filterValueTemporary = this.temporaryer.filter(r => {
        if ((r.position === value.position && r.employeeId === value.employeeId) || r.poaNo === value.poaNo) {
          return r
        }
      })
      if (type === 'approver') {
        if (action === 'add') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            // console.log('No Dup', filterValue)
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: value.id,
              companyId: value.companyId
            })
            // console.log('add approver:', this.approver)
            // console.log('add temporaryer:', this.temporaryer)
          }
        } else if (action === 'edit') {
          if (filterValue.length > 0) {
            // swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver[index].approverNo = index + 1
            this.approver[index]._id = value.id
            this.approver[index].employeeId = value.employeeId
            this.approver[index].approverName = value.name
            this.approver[index].position = value.position
            this.approver[index].email = value.email
            this.approver[index].approveType = value.approveType
            this.approver[index].userImg = value.userImg
            this.approver[index].failed_image = value.failed_image || false
          }
        }
      } else if (type === 'temporaryer') {
        if (action === 'add') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'มีข้อมูลรหัสพนักงานหรือเลขที่เอกสาร ซ้ำ', 'warning')
          } else {
            this.temporaryer.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              name: value.fileName,
              date: value.start + ' - ' + value.end,
              poaNo: value.poaNo,
              type: value.type,
              startDate: value.start,
              endDate: value.end,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdListTemporary.push({
              userId: value.id,
              // temporaryDate: date,
              file: value.file,
              name: value.fileName,
              date: value.date,
              poaNo: value.poaNo,
              companyId: value.companyId
            })
          }
        } else if (action === 'edit') {
          this.temporaryer[index].approverNo = index + 1
          this.temporaryer[index]._id = value.id
          this.temporaryer[index].employeeId = value.employeeId
          this.temporaryer[index].approverName = value.name
          this.temporaryer[index].position = value.position
          this.temporaryer[index].email = value.email
          this.temporaryer[index].name = value.fileName
          this.temporaryer[index].poaNo = value.poaNo
          this.temporaryer[index].date = value.date
          this.temporaryer[index].start = value.start
          this.temporaryer[index].end = value.end
          this.temporaryer[index].approveType = value.approveType
          this.temporaryer[index].userImg = value.userImg
          this.temporaryer[index].failed_image = value.failed_image || false
          // if (filterValueTemporary.length > 0) {
          //   swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          // } else {
          //   this.temporaryer[index].approverNo = index + 1
          //   this.temporaryer[index]._id = value.id
          //   this.temporaryer[index].employeeId = value.employeeId
          //   this.temporaryer[index].approverName = value.name
          //   this.temporaryer[index].position = value.position
          //   this.temporaryer[index].email = value.email
          //   this.temporaryer[index].fileName = value.name
          //   this.temporaryer[index].poaNo = value.poaNo
          //   this.temporaryer[index].date = value.date
          //   this.temporaryer[index].approveType = value.approveType
          //   this.temporaryer[index].userImg = value.userImg
          //   this.temporaryer[index].failed_image = value.failed_image || false
          // }
        }
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item, type) {
      // console.log('removeApprover', this.approver.indexOf(item))
      if (type === 'approver') {
        this.approver.splice(this.approver.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      } else if (type === 'temporaryer') {
        this.temporaryer.splice(this.temporaryer.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      }
    },
    async submitDataCreate (router) {
      var formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('certificate', this.filesCertificate[0])
      // formData.append('powerOfAttorney', this.filesCertificate[0])
      formData.append('powerOfAttorney', this.filesPoa[0])
      formData.append('groupCompanyId', this.groupName)
      formData.append('companyFullNameEng', this.companyNameFullEng)
      formData.append('companyFullNameTh', this.companyNameFullTh)
      formData.append('companyShortNameTh', this.companyNameShortTh)
      formData.append('companyShortNameEng', this.companyNameShortEng)
      formData.append('legalEntityTh', this.legalEntityTh)
      formData.append('legalEntityEng', this.legalEntityEng)
      formData.append('nameUseInDocTh', this.nameUseInDocTh)
      formData.append('nameUseInDocEng', this.nameUseInDocEng)
      formData.append('taxId', this.taxId)
      formData.append('email', this.email)
      formData.append('branchName', this.branchName)
      formData.append('branchCode', this.branchCode)
      formData.append('companyTelNo', this.companyTelNo)
      formData.append('companyMobilNumber', this.companyMobilNumber)
      formData.append('fax', this.fax)
      formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail))
      formData.append('companyLeader', JSON.stringify(this.userIdList))
      formData.append('region', this.region)
      formData.append('temporaryLeaderCompany', JSON.stringify(this.userIdListTemporary))
      const obj = formData
      if (this.taxId === null || this.taxId === '') {
        swal('คำเตือน', 'กรุณากรอกเลขที่ผู้เสียภาษีอากร', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        try {
          const res = await insertCompany(obj, this.$store.state.token)
          if (res.success) {
            this.text = 'คุณได้ทำการเพิ่มบริษัทเรียบร้อยแล้ว'
            this.snackbarColor = 'success'
            this.snackbar = true
            // this.$router.go(-1)
            this.$router.push(router)
          } else {
            swal('ผิดพลาด', res.data.msg, 'error')
            this.dialogConfirmSubmitData = false
            // this.loading = false
          }
        } catch (error) {
          console.log(error)
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.dialogConfirmSubmitData = false
          // this.loading = false
        } finally {
          // this.loadingEmployeeData = false
        }
      }
    },
    // async submitData () {
    //   // this.$refs.form.validate()
    //   var formData = new FormData()
    //   formData.append('image', this.files[0])
    //   formData.append('certificate', this.filesCertificate[0])
    //   // formData.append('powerOfAttorney', this.filesCertificate[0])
    //   formData.append('powerOfAttorney', this.filesPoa[0])
    //   formData.append('groupCompanyId', this.groupName)
    //   formData.append('companyFullNameEng', this.companyNameFullEng)
    //   formData.append('companyFullNameTh', this.companyNameFullTh)
    //   formData.append('companyShortNameTh', this.companyNameShortTh)
    //   formData.append('companyShortNameEng', this.companyNameShortEng)
    //   formData.append('legalEntityTh', this.legalEntityTh)
    //   formData.append('legalEntityEng', this.legalEntityEng)
    //   formData.append('nameUseInDocTh', this.nameUseInDocTh)
    //   formData.append('nameUseInDocEng', this.nameUseInDocEng)
    //   formData.append('taxId', this.taxId)
    //   formData.append('email', this.email)
    //   formData.append('branchName', this.branchName)
    //   formData.append('branchCode', this.branchCode)
    //   formData.append('companyTelNo', this.companyTelNo)
    //   formData.append('companyMobilNumber', this.companyMobilNumber)
    //   formData.append('fax', this.fax)
    //   formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail))
    //   formData.append('companyLeader', JSON.stringify(this.userIdList))
    //   formData.append('region', this.region)
    //   formData.append('temporaryLeaderCompany', JSON.stringify(this.userIdListTemporary))
    //   // *********************************************************
    //   await this.axios({
    //     method: 'post',
    //     url: `${this.api}/api/vMonk/companys/createCompany`,
    //     data: formData,
    //     headers: {
    //       authorization: this.tokenUser
    //     }
    //   }).then((response) => {
    //     this.text = 'คุณได้ทำการเพิ่มบริษัทเรียบร้อยแล้ว'
    //     this.snackbarColor = 'success'
    //     this.snackbar = true
    //     this.$router.go(-1)
    //   }).catch(e => {
    //     console.dir(e)
    //     console.log(e)
    //     swal('Error', 'บันทึกบริษัท ไม่สำเร็จ!', 'error')
    //   })
    //   // if (this.files[0] === undefined ||
    //   // this.filesCertificate[0] === undefined ||
    //   // this.filesPoa[0] === undefined ||
    //   // this.companyNameShortTh === '' ||
    //   // this.companyNameShortEng === '' ||
    //   // this.legalEntityTh === '' ||
    //   // this.companyNameFullTh === '' ||
    //   // this.nameUseInDocTh === '' ||
    //   // this.legalEntityEng === '' ||
    //   // this.companyNameFullEng === '' ||
    //   // this.nameUseInDocEng === '' ||
    //   // this.taxId === '' ||
    //   // this.email === '' ||
    //   // this.region === '' ||
    //   // this.branchName === '' ||
    //   // this.branchCode === '' ||
    //   // this.companyMobilNumber === '' ||
    //   // this.companyAddressDetail.address === '' ||
    //   // this.companyAddressDetail.province === '' ||
    //   // this.companyAddressDetail.district === '' ||
    //   // this.companyAddressDetail.subDistrict === '' ||
    //   // this.companyAddressDetail.postCode === ''
    //   // ) {
    //   //   swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
    //   // } else {
    //   // }
    // },
    addFiles (type) {
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
        // console.log('add files', this.$refs.PickfilesCertificate)
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      this.loadingFile = true
      if (type === 'certificate') {
        this.filesCertificate = []
        var uploadedFilesCertificate = this.$refs.PickfilesCertificate.files
        for (let i = 0; i < uploadedFilesCertificate.length; i++) {
          var dotindexCertificate = uploadedFilesCertificate[i].name.lastIndexOf('.')
          var FileExtension = uploadedFilesCertificate[i].name.substr(dotindexCertificate + 1).toLowerCase()

          if (FileExtension === 'pdf') {
            // console.log(uploadedFiles[i].name, 'ok')
            this.filesCertificate.push(uploadedFilesCertificate[i])
            setTimeout(() => {
              this.loadingFile = false
            }, 2000)
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesCertificate[i].name.substr(-4)}`, 'warning')
            this.loadingFile = false
          }
        }
      } else if (type === 'poa') {
        this.filesPoa = []
        var uploadedFilesPoa = this.$refs.PickfilesPoa.files
        for (let i = 0; i < uploadedFilesPoa.length; i++) {
          var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
          var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()

          if (FileExtensionPoa === 'pdf') {
            this.filesPoa.push(uploadedFilesPoa[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          }
        }
      }
    },
    removeFile (key, type) {
      if (type === 'certificate') {
        this.filesCertificate.splice(key, 1)
        const input = this.$refs.PickfilesCertificate
        input.type = 'text'
        input.type = 'file'
      } else if (type === 'poa') {
        this.filesPoa.splice(key, 1)
        const input = this.$refs.PickfilesPoa
        input.type = 'text'
        input.type = 'file'
      }
      // // console.log('remove key', key)
      // console.log('FILE ', this.files)
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name.substr(dotindex + 1).toLowerCase()
      if (FileExtension === 'jpg' || FileExtension === 'png' || FileExtension === 'JPG' || FileExtension === 'PNG') {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      } else {
        swal('คำเตือน', `ไม่รองรับไฟล์${uploadedImage[0].name.substr(-4)}`, 'warning')
      }
    }
  }
}
// src\css\Re-Desing\Gobal-Design.css
</script>
<style scoped>
@import '../../css/Re-Desing/Gobal-Design.css';
@import '../../css/Re-Desing/Datatable.css';
@import '../../css/Re-Desing/Search-Item.css';
.border-table-company {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}

</style>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.base-image-input {
  display: block;
  width: 100px;
  height: 100px;
  /* padding: 8%; */
  border-radius: 5px;
  cursor: pointer;
  background-size: contain;
  background-position: center center;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url('../../assets/icons/no-company-7.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../assets/icons/no-company-7.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.ra-button-company {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-company {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.companymanage >>>.v-data-table__wrapper {
  overflow-x: auto ;
  overflow-y: hidden ;
}
</style>
